<!--
 * @Author: your name
 * @Date: 2021-01-05 08:47:52
 * @LastEditTime: 2021-01-08 09:36:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sunshineServiceHall\src\components\appeal\reply.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link to="/home">阳光校务服务大厅</router-link>
        &gt; 阳光校务信息列表清单
      </div>
    </div>
    <div class="z_title1" style="margin-top: 10px">查询条件</div>
    <div class="searchBody">
      <span>类别：</span>
      <a-select v-model="classify" placeholder="全部" style="width: 200px">
        <a-select-option value>全部</a-select-option>
        <a-select-option v-for="(item, index) in typeList" :key="index" :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
      <span style="margin-left: 5px">受理单号：</span>
      <a-input v-model="code" style="width: 200px"></a-input>
      <span style="margin-left: 5px">关键字：</span>
      <a-input
          placeholder="姓名、联系方式、问题标题"
          v-model="queryInfo"
          style="width: 200px"
      ></a-input>
      <a-button style="margin-left: 5px" @click="getList" type="primary">搜索</a-button>
    </div>
    <a-table
        :columns="columns"
        :data-source="list"
        rowKey="id"
        bordered
        :pagination="pagination"
        style="margin-top: 15px"
        @change="handlerChange"
    >
      <a slot="name" slot-scope="t, r" s @click="go('/replyInfo', r)">
        {{ t }}
      </a>
    </a-table>
  </div>
</template>

<script>
import {getAction, postAction} from "@/api/manage";

export default {
  data() {
    return {
      columns: [
        {
          dataIndex: "code",
          title: "流水号",
          align: "center",
        },
        {
          title: "标题",
          align: "center",
          dataIndex: "name",
          scopedSlots: {customRender: "name"},
        },
        {
          title: "日期",
          dataIndex: "gmtCreate",
          align: "center",
        },
        {
          title: "类别",
          align: "center",
          dataIndex: "typeName",
        },
        {
          title: "受理单位/领导",
          dataIndex: "orgName",
          align: "center",
        },
        {
          title: "处理状态",
          align: "center",
          dataIndex: "status",
          customRender: (t, r, i) => {
            return t === 1
                ? "已受理"
                : t === 2
                    ? "已完成"
                    : t == 3
                        ? "转交中"
                        : t == 4
                            ? "不受理"
                            : "";
          },
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ["1", "5", "10", "20", "30"],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      typeList: [],
      list: [],
      classify: undefined,
      code: "",
      queryInfo: "",
    };
  },
  created() {
    this.classify = this.$route.query.classify ? this.$route.query.classify : undefined
  },
  mounted() {
    this.getList();
    this.getTypeList();
  },
  methods: {
    go(url, r) {
      this.$router.push({
        path: url,
        query: {
          record: encodeURIComponent(JSON.stringify(r)),
        },
      });
    },
    getTypeList() {
      postAction("/user/appeal/category/selectOneList").then((data) => {
        this.typeList = data.data.list;
      });
    },
    handlerChange(pagination) {
      this.pagination = pagination;
      this.getList();
    },
    getList() {

      postAction("/user/appeal/appeal/listByClassify", {
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        code: this.code,
        queryInfo: this.queryInfo,
        classify: this.classify,
      }).then((data) => {
        this.list = data.data.list;
        this.pagination.total = data.data.total;
      });
    },
  },
};
</script>

<style scoped>
.itemsList {
  margin-top: 20px;
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.searchBody {
  padding: 10px;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
}
</style>
